/**
 * True when the event target is a text field / editable surface where
 * letter shortcuts must not fire (typing "a" should not toggle annotation mode).
 */
export function isTypingKeyboardTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;

  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;

  return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
}

/** Platform-aware modifier label for help UI (⌘ on Apple, Ctrl elsewhere). */
export function getShortcutModKeyLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl';
  const platform = navigator.platform || '';
  const ua = navigator.userAgent || '';
  if (/Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS X/i.test(ua)) return '⌘';
  return 'Ctrl';
}
